<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <section>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div class="boss-page-title-layout">
            <div>
              <h1 class="boss-page-title boss-page-title-layout-title">
                応募者管理
              </h1>
            </div>
            <entry-display-target
              :entry-objects="entryObjects"
              @setDisplayTargets="setDisplayTargets"
              @filteredUpdate="setEntryObjects"
            />
          </div>
          <entry-filter
            :entry-objects="entryObjects"
            @filteredUpdate="setEntryObjects"
          />
          <div class="boss-batch-container clearfix padding-top-0">
            <div class="float-left boss-check-container">
              全
              <span
                class="boss-check-number"
                data-test="displayed-count"
              >{{ isLoading ? '...' : displayedCount }}</span>名
              <span data-test="page-label">{{ countPageLabel }}</span>
            </div>
            <entry-bulk-update
              :entry-ids="checkedEntryIds"
              :select-limit="selectLimit"
              data-test="bulk-update"
              @updated="fetch"
            />
          </div>
          <div>
            <div class="boss-layout boss-layout-gap-between">
              <div class="is-boss-only-pc">
                <router-link
                  :to="{ name: 'settingEntryColumns' }"
                  data-test="settings-entry"
                  class="boss-button boss-button-compact"
                >
                  <img src="@/assets/images/icon-pen.svg">表示情報を編集
                </router-link>
              </div>
              <sort-pull-down
                :objects="entryObjects"
                :sort-item-map="sortItemMap"
                @setObjects="setEntryObjects"
              />
            </div>
          </div>
          <div
            id="entry-entries"
            data-test="entry-entry-wrap"
            class="boss-table-wrap"
          >
            <entry-entries
              ref="entryEntries"
              :display-target="displayTargets"
              :entry-objects="entryObjects"
              :count="count"
              :count-limit="countLimit"
              :select-limit="selectLimit"
              @fetch="fetch"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import EntryFilter from '@/components/molecules/EntryFilter'
import EntryDisplayTarget from '@/components/molecules/EntryDisplayTarget'
import SortPullDown from '@/components/atoms/SortPullDown'
import EntryBulkUpdate from '@/components/molecules/EntryBulkUpdate'
import { entryResultSort } from '@/lib/labelValueMappings'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import EntryEntries from '@/components/organisms/EntryEntries'
import Indicator from '@/lib/indicator'

export default {
  name: 'EntryTop',
  components: {
    EntryEntries,
    EntryDisplayTarget,
    EntryFilter,
    SortPullDown,
    EntryBulkUpdate
  },
  data () {
    return {
      entryObjects: [],
      // 子コンポーネントに表示対象者を渡すために追加
      displayTargets: [],
      isFetchCallForActivated: false,
      count: 0
    }
  },
  computed: {
    sortItemMap () {
      return entryResultSort
    },
    checkedEntryIds () {
      return _(this.entryObjects).filter('isChecked').map(_.property('entry.id')).value()
    },
    renderingEntryObjects () {
      return _(this.entryObjects)
        .filter('isShow')
        .filter('isDisplayTarget')
        .value()
    },
    displayedCount () {
      return this.isLoading ? null : this.renderingEntryObjects.length
    },
    ...mapGetters('settings', [
      'allStatuses'
    ]),
    countLimit: () => 5000,
    selectLimit: () => 2000,
    countFrom () {
      return this.displayedCount ? (this.$refs.entryEntries.currentPage - 1) * this.countLimit + 1 : 0
    },
    countTo () {
      return this.displayedCount ? (this.$refs.entryEntries.currentPage - 1) * this.countLimit + this.displayedCount : 0
    },
    isLoading: () => Indicator.getLoadingStatus(),
    countPageLabel () {
      return (this.count > this.countLimit) ? `${this.isLoading ? '...' : this.countFrom}〜${this.isLoading ? '...' : this.countTo}名まで表示中`
        : ''
    }
  },
  created () {
    this.fetch()
  },
  activated () {
    this.isFetchCallForActivated && this.fetch()
  },
  deactivated () {
    this.$set(this, 'isFetchCallForActivated', true)
  },
  methods: {
    fetch () {
      Indicator.emitShow()
      this.fetchEntryCount().then(response => {
        this.$set(this, 'count', response.data)
        this.fetchEntries(this.$refs.entryEntries.currentPage)
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    fetchEntryCount () {
      return this.$http.secured.get('/entry/view/entries/_count')
    },
    fetchEntries (page = 1) {
      this.$http.secured.get(`/entry/view/entries/pages/${page}`)
        .then(response => {
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (entries) {
      this.$set(this, 'entryObjects', _(entries).map(entry => {
        // 選考ステータスの表示順を付与
        return {
          isShow: true,
          isDisplayTarget: true,
          isChecked: false,
          entry: _.set(entry, 'currentSelection.statusOrder', this.getStatusOrder(entry.currentSelection.statusId))
        }
      }).value())
    },
    setEntryObjects (entryObjects) {
      this.$set(this, 'entryObjects', entryObjects)
    },
    getStatusOrder (statusId) {
      return statusId ? _.findIndex(this.allStatuses, status => status.id === statusId) : null
    },
    setDisplayTargets (displayTargets) {
      this.$set(this, 'displayTargets', displayTargets)
    }
  }
}
</script>
